import translator from '@Components/Utilities/Translator';
import Button from '@mui/material/Button';

const ConsignmentRequestItem = ({
    request,
    handleDeletion
}
) => {

    const isExpired = !!request?.Request?.IsExpired;

    return (
        <div className='consignment-wrap cf consignment-request'>
            <div className='consignment-request-top'>
                <div className='consignment-request-image'>
                    {request?.RequestImageURL &&
                        <>
                            <img
                                src={request.RequestImageURL}
                                alt={`${request.Request.Manufacturer} ${request.Request.Model}`}
                                style={{ display: 'block', maxWidth: '392px', maxHeight: '294px', width: '100%' }}/>
                            <br />
                        </>
                    }
                </div>
                <div className='column10 left consignment-request-info'>
                    <div className='column3 left'>
                        {isExpired &&
                            <div className="font15 red bold">{translator.translate('sandhills.crm.dscrm.expired')}</div>
                        }
                        <div className="font15 bold">
                            {request.Request.CategoryID
                                ? request.Category
                                : null}
                        </div>
                        {request.Request?.EquipmentYear && (
                            <span>{request.Request.EquipmentYear} </span>
                        )}
                        {request.Request.Manufacturer} {request.Request.Model}
                    </div>
                    <div className='column4 left'>
                        <strong>{translator.translate('sandhills.condition')}:</strong> {request.Request.EquipmentCondition}
                        <br />
                        {request.Request.PreferredSaleDate &&
                            <>
                                <strong>{translator.translate('sandhills.preferredsaledate')}:</strong> {new Date(request.Request.PreferredSaleDate).toLocaleDateString(undefined, {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric'
                                })}
                            </>
                        }
                    </div>
                    <div className='column5 right'>
                        <strong>{translator.translate('sandhills.createdon')}:</strong>{' '}
                        {request.Request.CreatedOnUTCDateTime
                            ? new Date(request.Request.CreatedOnUTCDateTime).toLocaleString(undefined, {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })
                            : ''}
                        <br />
                        <strong>{translator.translate('sandhills.requestnumber')}:</strong> {request.Request.EquipmentMessageID}
                        <br />
                        <br />
                        <a className='consignment-request-button' onClick={(e) => handleDeletion(e, request)}>{translator.translate('sandhills.delete')}</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ConsignmentRequestItem;
